export const templates = (state) => state.templates.templates;
export const isChanged = (state) => state.templates.isChanged;
